// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   HIERARCHY TREE COMPONENT STYLES
   ============================================ */

.hierarchy-tree {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.tree-empty {
  padding: var(--space-6) var(--space-4);
  text-align: center;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.tree-empty p {
  margin: 0;
  line-height: var(--leading-relaxed);
}

.sidebar-tree {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

/* ============================================
   TREE DOMAIN
   ============================================ */

.tree-domain {
  display: flex;
  flex-direction: column;
}

.tree-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-fast);
  /* space-1 (not space-2): the row is justify-content: space-between, so
     on wide screens the count is pushed to the far edge and this gap
     never binds — it only matters once the label grows tight, where the
     extra 4px of label width is worth more than the separation. */
  gap: var(--space-1);
}

.tree-domain-header {
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  font-size: var(--text-sm);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
}

.tree-domain-header:hover {
  background: var(--bg-surface-hover);
}

/* Domain right side — edit btn + count */
.tree-domain-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tree-domain-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.tree-domain-edit-btn,
.tree-action-merge {
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.tree-domain-header:hover .tree-domain-actions,
.tree-domain-header:focus-within .tree-domain-actions {
  opacity: 1;
}

.tree-domain-header:hover .tree-domain-edit-btn,
.tree-domain-header:hover .tree-action-merge,
.tree-domain-header:focus-within .tree-domain-edit-btn,
.tree-domain-header:focus-within .tree-action-merge {
  opacity: 1;
}

/* Inline rename input */
.tree-domain-rename-input {
  background: var(--bg-surface);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-sm);
  color: var(--text-primary);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
  padding: 1px 6px;
  outline: none;
  width: 100%;
  min-width: 0;
}

.tree-domain-rename-input:focus {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 1px var(--accent-primary);
}

/* NAPLEX Review domain — distinct accent */
.tree-domain--naplex {
  border-left: 3px solid #f97316;
  margin-left: -3px;
}

.tree-domain-header--naplex {
  background: linear-gradient(90deg, rgba(249, 115, 22, 0.08) 0%, transparent 60%);
}

.tree-domain-header--naplex .tree-label {
  color: #f97316;
}

.tree-domain-header--naplex:hover {
  background: linear-gradient(90deg, rgba(249, 115, 22, 0.15) 0%, transparent 60%);
}

.tree-domain-header--naplex .tree-count {
  background: rgba(249, 115, 22, 0.15);
  color: #f97316;
}

.tree-domain-header--naplex {
  cursor: pointer;
}

.tree-domain-arrow {
  font-size: 1.2rem;
  color: #f97316;
  opacity: 0.6;
  flex-shrink: 0;
  transition: opacity var(--transition-fast), transform var(--transition-fast);
}

.tree-domain-header--naplex:hover .tree-domain-arrow {
  opacity: 1;
  transform: translateX(2px);
}

.tree-domain--ptcb {
  border-left: 3px solid var(--dlc-ptcb);
  margin-left: -3px;
}

.tree-domain-header--ptcb {
  background: linear-gradient(90deg, rgba(var(--dlc-ptcb-rgb), 0.1) 0%, transparent 60%);
  cursor: pointer;
}

.tree-domain-header--ptcb .tree-label {
  color: var(--dlc-ptcb);
}

.tree-domain-header--ptcb:hover {
  background: linear-gradient(90deg, rgba(var(--dlc-ptcb-rgb), 0.18) 0%, transparent 60%);
}

.tree-domain-header--ptcb .tree-count {
  background: rgba(var(--dlc-ptcb-rgb), 0.16);
  color: var(--dlc-ptcb);
}

.tree-domain-header--ptcb .tree-domain-arrow {
  color: var(--dlc-ptcb);
}

.tree-domain-header--ptcb:hover .tree-domain-arrow {
  opacity: 1;
  transform: translateX(2px);
}

/* Chevron button */
.tree-chevron {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--text-subtle);
  font-size: var(--text-base);
  line-height: 1;
  transition: transform var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.tree-chevron:hover {
  color: var(--text-secondary);
}

.tree-chevron.expanded {
  transform: rotate(90deg);
}

/* Checkbox */
.tree-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: var(--accent-primary);
}

.tree-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* ============================================
   TREE CHILDREN
   ============================================ */

.tree-children {
  margin-left: var(--space-2);
  padding-left: var(--space-3);
  border-left: 1px solid var(--border-subtle);
  overflow: hidden;
  transition: max-height var(--transition-base);
}

.tree-children.tree-collapsed {
  display: none;
}

/* ============================================
   TREE EXAM
   ============================================ */

.tree-exam {
  margin-top: var(--space-1);
}

.tree-exam-header {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  padding: var(--space-2) var(--space-2);
}

.tree-exam-header:hover {
  background: var(--bg-surface-hover);
}

.tree-exam-header.selected {
  background: var(--accent-primary-muted);
  color: var(--accent-primary);
  border-left: 2px solid var(--accent-primary);
  margin-left: -2px;
}

.tree-domain-header.selected {
  background: var(--accent-primary-muted);
  color: var(--accent-primary);
  border-left: 2px solid var(--accent-primary);
  margin-left: -2px;
}

.tree-exam-label {
  font-weight: var(--font-weight-medium);
  font-style: italic;
}

.tree-exam-children {
  margin-left: var(--space-2);
  overflow: hidden;
  transition: max-height var(--transition-base);
}

.tree-exam-children.tree-collapsed {
  display: none;
}

/* ============================================
   TREE TOPIC
   ============================================ */

.tree-topic {
  margin-top: 2px;
}

.tree-topic-header {
  font-size: var(--text-sm);
  color: var(--text-muted);
  padding: var(--space-2) var(--space-2);
}

.tree-topic-header:hover {
  background: var(--bg-surface);
  color: var(--text-secondary);
}

.tree-topic-header.selected {
  background: var(--accent-primary-muted);
  color: var(--accent-primary);
  border-left: 2px solid var(--accent-primary);
  margin-left: -2px;
}

/* ============================================
   TREE TOPIC ACTIONS (hover reveal)
   ============================================ */

.tree-topic-right {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  flex-shrink: 0;
}

.tree-topic-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.tree-topic-header:hover .tree-topic-actions {
  opacity: 1;
}

.tree-action-btn {
  background: none;
  border: none;
  padding: 3px;
  cursor: pointer;
  color: var(--text-subtle);
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
}

.tree-action-btn:hover {
  color: var(--text-primary);
  background: var(--bg-surface-hover);
}

.tree-action-btn.tree-action-delete:hover {
  color: var(--accent-error);
  background: rgba(239, 68, 68, 0.1);
}

.tree-action-btn.tree-action-add {
  color: #22c55e;
}

.tree-action-btn.tree-action-add:hover {
  color: #4ade80;
  background: rgba(34, 197, 94, 0.1);
}

.tree-action-btn.tree-action-merge:hover {
  color: #93c5fd;
  background: rgba(59, 130, 246, 0.12);
}

/* ============================================
   TREE LABEL & COUNT BADGE
   ============================================ */

.tree-label {
  flex: 1 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  /* word-break: normal keeps whole words intact; overflow-wrap: anywhere
     only breaks inside a word when that single word is genuinely wider
     than the column. Prevents mid-word splits like "HEMATOLOG / Y AND...". */
  word-break: normal;
  overflow-wrap: anywhere;
  line-height: var(--leading-normal);
}

.tree-count {
  font-size: var(--text-xs);
  color: var(--text-subtle);
  background: var(--bg-surface);
  padding: 2px var(--space-2);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  min-width: 20px;
  text-align: center;
}

.tree-count-group {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}

.tree-count-synthetic {
  color: #d946ef;
  background: rgba(217, 70, 239, 0.12);
}

.tree-count-manual {
  color: #06b6d4;
  background: rgba(6, 182, 212, 0.12);
}

.tree-count-notes {
  color: #06b6d4;
  background: rgba(6, 182, 212, 0.12);
  font-weight: var(--font-weight-medium);
}

/* ============================================
   ITEM CONTENT WRAPPER
   ============================================ */

.tree-item-content {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex: 1 1;
  min-width: 0; /* Allow flex children to shrink */
}

/* ============================================
   ACCESSIBILITY
   ============================================ */

.tree-chevron:focus-visible,
.tree-checkbox:focus-visible,
.tree-item:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* ============================================
   PROCESSING STATE
   ============================================ */

.tree-processing .tree-label {
  color: var(--text-subtle);
  font-style: italic;
}

.tree-processing-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent-warning, #f59e0b);
  flex-shrink: 0;
  animation: tree-pulse 1.5s ease-in-out infinite;
}

.tree-processing-track {
  height: 2px;
  background: rgba(245, 158, 11, 0.15);
  border-radius: 1px;
  margin: 0 var(--space-2) 2px;
  overflow: hidden;
}

.tree-processing-fill {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
  border-radius: 1px;
  transition: width 0.6s ease-out;
}

.tree-phase-hint {
  font-size: 0.55rem;
  color: var(--accent-warning, #f59e0b);
  opacity: 0.7;
  flex-shrink: 0;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  font-weight: var(--font-weight-medium);
}

@keyframes tree-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

/* Uploading state — purple/indigo pulsing */
.tree-processing-track--uploading {
  background: rgba(139, 92, 246, 0.15);
}

.tree-processing-fill--uploading {
  background: linear-gradient(90deg, #8b5cf6, #a78bfa);
  animation: tree-upload-pulse 1.5s ease-in-out infinite;
}

@keyframes tree-upload-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.tree-processing-dot--uploading {
  background: #8b5cf6;
}

.tree-phase-hint--uploading {
  color: #8b5cf6 !important;
}

/* Cloud parse mode — sky blue instead of amber */
.tree-processing-track--cloud {
  background: rgba(14, 165, 233, 0.15);
}

.tree-processing-fill--cloud {
  background: linear-gradient(90deg, #0ea5e9, #38bdf8);
}

.tree-processing-dot--cloud {
  background: #0ea5e9;
}

.tree-phase-hint--cloud {
  color: #0ea5e9 !important;
}

/* Concept-card forging — denim blue, distinct from sky-cloud */
.tree-processing-track--forging {
  background: rgba(59, 130, 246, 0.15);
}

.tree-processing-fill--forging {
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  animation: tree-upload-pulse 1.5s ease-in-out infinite;
}

.tree-processing-dot--forging {
  background: #3b82f6;
  box-shadow: 0 0 6px rgba(59, 130, 246, 0.55);
}

.tree-phase-hint--forging {
  color: #60a5fa !important;
}

/* Forging sub-row — appears UNDER its parent topic/deck row */
.tree-forging-row {
  position: relative;
  margin-left: var(--space-4, 12px);
  padding: 4px var(--space-2, 8px);
  display: flex;
  align-items: center;
  gap: var(--space-2, 8px);
  font-size: 0.7rem;
  color: rgba(96, 165, 250, 0.85);
  border-left: 1px solid rgba(59, 130, 246, 0.2);
}

.tree-forging-row .tree-label {
  font-style: italic;
  font-size: 0.7rem;
  color: rgba(96, 165, 250, 0.78);
}

.tree-forging-row .tree-processing-track {
  position: absolute;
  left: var(--space-2, 8px);
  right: var(--space-2, 8px);
  bottom: 0;
  margin: 0;
}

/* Reduce motion for users who prefer it */
@media (prefers-reduced-motion: reduce) {
  .tree-chevron,
  .tree-children,
  .tree-exam-children,
  .tree-item,
  .tree-processing-dot,
  .tree-processing-fill {
    transition: none;
    animation: none;
  }
}

/* Hover-action groups overlay the row's right edge instead of reserving
   layout space. .tree-topic-actions / .tree-domain-actions are opacity:0
   at rest but, as in-flow flex children, still consumed ~58px of every
   row's horizontal budget — squeezing .tree-label into ~126px of a 280px
   sidebar and forcing premature 2-line ellipsis on long deck/topic names.

   Taking them out of flow (position: absolute) gives .tree-label the full
   row width at every viewport. The opacity-based hover reveal is unchanged;
   pointer-events is gated so the invisible overlay never blocks clicks. */
.tree-item {
  position: relative;
}

.tree-topic-actions,
.tree-domain-actions {
  position: absolute;
  right: var(--space-2);
  top: 50%;
  transform: translateY(-50%);
  background: var(--bg-surface-hover, rgba(255, 255, 255, 0.06));
  border-radius: var(--radius-sm);
  padding: 2px 3px;
  pointer-events: none;
  z-index: 2;
}

.tree-topic-header:hover .tree-topic-actions,
.tree-topic-header:focus-within .tree-topic-actions,
.tree-domain-header:hover .tree-domain-actions,
.tree-domain-header:focus-within .tree-domain-actions {
  pointer-events: auto;
}

/* Sub-desktop chrome tightening (Surface, split-screen, small laptops).
   At <=1800px the count badge's var(--space-2) padding + 20px min-width +
   var(--space-3) row padding stay fixed even as the sidebar narrows,
   eating first-line label width. Tightening them gives long deck/topic
   names more room before they wrap. 1800px is chosen to catch a Surface
   at its real CSS width (~1700px) while leaving a 1440p monitor at 100%
   or 125% scaling (2048-2560px CSS) untouched. */
@media (max-width: 1800px) {
  .tree-item {
    padding: var(--space-2) var(--space-2);
  }

  .tree-count {
    padding: 2px var(--space-1);
    min-width: 16px;
  }

  .tree-topic-right,
  .tree-domain-right {
    gap: 2px;
  }

  .tree-count-group {
    gap: 2px;
  }
}

/* Narrow-viewport sidebar fixes (Surface, split-screen, small laptops).
   The sidebar drops to 260px width at <=1024px (SidebarShell.css). At that
   width, also tighten child indent to reclaim a few more pixels. */
@media (max-width: 1024px) {
  .tree-children {
    margin-left: var(--space-1);
    padding-left: var(--space-2);
  }

  .tree-topic-header,
  .tree-exam-header {
    padding: var(--space-2) var(--space-1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hierarchy/HierarchyTree.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC;;;kEAGgE;EAChE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA,2CAA2C;AAC3C;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,sFAAsF;EACtF,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;EAC3C,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;;iDAEiD;;AAEjD;EACE,SAAO;EACP,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB;;6EAE2E;EAC3E,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAO;EACP,YAAY,EAAE,kCAAkC;AAClD;;AAEA;;iDAEiD;;AAEjD;;;EAGE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,4CAA4C;AAC5C;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,SAAS;EACT,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE;;;;;;IAME,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;;;;;;;;0EAQ0E;AAC1E;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,8DAA8D;EAC9D,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;;;iDAMiD;AACjD;EACE;IACE,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;;mEAEmE;AACnE;EACE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,sCAAsC;EACxC;AACF","sourcesContent":["/* ============================================\n   HIERARCHY TREE COMPONENT STYLES\n   ============================================ */\n\n.hierarchy-tree {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.tree-empty {\n  padding: var(--space-6) var(--space-4);\n  text-align: center;\n  color: var(--text-muted);\n  font-size: var(--text-sm);\n}\n\n.tree-empty p {\n  margin: 0;\n  line-height: var(--leading-relaxed);\n}\n\n.sidebar-tree {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n/* ============================================\n   TREE DOMAIN\n   ============================================ */\n\n.tree-domain {\n  display: flex;\n  flex-direction: column;\n}\n\n.tree-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  /* space-1 (not space-2): the row is justify-content: space-between, so\n     on wide screens the count is pushed to the far edge and this gap\n     never binds — it only matters once the label grows tight, where the\n     extra 4px of label width is worth more than the separation. */\n  gap: var(--space-1);\n}\n\n.tree-domain-header {\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  font-size: var(--text-sm);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wide);\n}\n\n.tree-domain-header:hover {\n  background: var(--bg-surface-hover);\n}\n\n/* Domain right side — edit btn + count */\n.tree-domain-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tree-domain-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.tree-domain-edit-btn,\n.tree-action-merge {\n  opacity: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.tree-domain-header:hover .tree-domain-actions,\n.tree-domain-header:focus-within .tree-domain-actions {\n  opacity: 1;\n}\n\n.tree-domain-header:hover .tree-domain-edit-btn,\n.tree-domain-header:hover .tree-action-merge,\n.tree-domain-header:focus-within .tree-domain-edit-btn,\n.tree-domain-header:focus-within .tree-action-merge {\n  opacity: 1;\n}\n\n/* Inline rename input */\n.tree-domain-rename-input {\n  background: var(--bg-surface);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-sm);\n  color: var(--text-primary);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wide);\n  padding: 1px 6px;\n  outline: none;\n  width: 100%;\n  min-width: 0;\n}\n\n.tree-domain-rename-input:focus {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 1px var(--accent-primary);\n}\n\n/* NAPLEX Review domain — distinct accent */\n.tree-domain--naplex {\n  border-left: 3px solid #f97316;\n  margin-left: -3px;\n}\n\n.tree-domain-header--naplex {\n  background: linear-gradient(90deg, rgba(249, 115, 22, 0.08) 0%, transparent 60%);\n}\n\n.tree-domain-header--naplex .tree-label {\n  color: #f97316;\n}\n\n.tree-domain-header--naplex:hover {\n  background: linear-gradient(90deg, rgba(249, 115, 22, 0.15) 0%, transparent 60%);\n}\n\n.tree-domain-header--naplex .tree-count {\n  background: rgba(249, 115, 22, 0.15);\n  color: #f97316;\n}\n\n.tree-domain-header--naplex {\n  cursor: pointer;\n}\n\n.tree-domain-arrow {\n  font-size: 1.2rem;\n  color: #f97316;\n  opacity: 0.6;\n  flex-shrink: 0;\n  transition: opacity var(--transition-fast), transform var(--transition-fast);\n}\n\n.tree-domain-header--naplex:hover .tree-domain-arrow {\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n.tree-domain--ptcb {\n  border-left: 3px solid var(--dlc-ptcb);\n  margin-left: -3px;\n}\n\n.tree-domain-header--ptcb {\n  background: linear-gradient(90deg, rgba(var(--dlc-ptcb-rgb), 0.1) 0%, transparent 60%);\n  cursor: pointer;\n}\n\n.tree-domain-header--ptcb .tree-label {\n  color: var(--dlc-ptcb);\n}\n\n.tree-domain-header--ptcb:hover {\n  background: linear-gradient(90deg, rgba(var(--dlc-ptcb-rgb), 0.18) 0%, transparent 60%);\n}\n\n.tree-domain-header--ptcb .tree-count {\n  background: rgba(var(--dlc-ptcb-rgb), 0.16);\n  color: var(--dlc-ptcb);\n}\n\n.tree-domain-header--ptcb .tree-domain-arrow {\n  color: var(--dlc-ptcb);\n}\n\n.tree-domain-header--ptcb:hover .tree-domain-arrow {\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n/* Chevron button */\n.tree-chevron {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: var(--text-subtle);\n  font-size: var(--text-base);\n  line-height: 1;\n  transition: transform var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.tree-chevron:hover {\n  color: var(--text-secondary);\n}\n\n.tree-chevron.expanded {\n  transform: rotate(90deg);\n}\n\n/* Checkbox */\n.tree-checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  flex-shrink: 0;\n  accent-color: var(--accent-primary);\n}\n\n.tree-checkbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* ============================================\n   TREE CHILDREN\n   ============================================ */\n\n.tree-children {\n  margin-left: var(--space-2);\n  padding-left: var(--space-3);\n  border-left: 1px solid var(--border-subtle);\n  overflow: hidden;\n  transition: max-height var(--transition-base);\n}\n\n.tree-children.tree-collapsed {\n  display: none;\n}\n\n/* ============================================\n   TREE EXAM\n   ============================================ */\n\n.tree-exam {\n  margin-top: var(--space-1);\n}\n\n.tree-exam-header {\n  font-size: var(--text-sm);\n  color: var(--text-secondary);\n  padding: var(--space-2) var(--space-2);\n}\n\n.tree-exam-header:hover {\n  background: var(--bg-surface-hover);\n}\n\n.tree-exam-header.selected {\n  background: var(--accent-primary-muted);\n  color: var(--accent-primary);\n  border-left: 2px solid var(--accent-primary);\n  margin-left: -2px;\n}\n\n.tree-domain-header.selected {\n  background: var(--accent-primary-muted);\n  color: var(--accent-primary);\n  border-left: 2px solid var(--accent-primary);\n  margin-left: -2px;\n}\n\n.tree-exam-label {\n  font-weight: var(--font-weight-medium);\n  font-style: italic;\n}\n\n.tree-exam-children {\n  margin-left: var(--space-2);\n  overflow: hidden;\n  transition: max-height var(--transition-base);\n}\n\n.tree-exam-children.tree-collapsed {\n  display: none;\n}\n\n/* ============================================\n   TREE TOPIC\n   ============================================ */\n\n.tree-topic {\n  margin-top: 2px;\n}\n\n.tree-topic-header {\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n  padding: var(--space-2) var(--space-2);\n}\n\n.tree-topic-header:hover {\n  background: var(--bg-surface);\n  color: var(--text-secondary);\n}\n\n.tree-topic-header.selected {\n  background: var(--accent-primary-muted);\n  color: var(--accent-primary);\n  border-left: 2px solid var(--accent-primary);\n  margin-left: -2px;\n}\n\n/* ============================================\n   TREE TOPIC ACTIONS (hover reveal)\n   ============================================ */\n\n.tree-topic-right {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n  flex-shrink: 0;\n}\n\n.tree-topic-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.tree-topic-header:hover .tree-topic-actions {\n  opacity: 1;\n}\n\n.tree-action-btn {\n  background: none;\n  border: none;\n  padding: 3px;\n  cursor: pointer;\n  color: var(--text-subtle);\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n}\n\n.tree-action-btn:hover {\n  color: var(--text-primary);\n  background: var(--bg-surface-hover);\n}\n\n.tree-action-btn.tree-action-delete:hover {\n  color: var(--accent-error);\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.tree-action-btn.tree-action-add {\n  color: #22c55e;\n}\n\n.tree-action-btn.tree-action-add:hover {\n  color: #4ade80;\n  background: rgba(34, 197, 94, 0.1);\n}\n\n.tree-action-btn.tree-action-merge:hover {\n  color: #93c5fd;\n  background: rgba(59, 130, 246, 0.12);\n}\n\n/* ============================================\n   TREE LABEL & COUNT BADGE\n   ============================================ */\n\n.tree-label {\n  flex: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  /* word-break: normal keeps whole words intact; overflow-wrap: anywhere\n     only breaks inside a word when that single word is genuinely wider\n     than the column. Prevents mid-word splits like \"HEMATOLOG / Y AND...\". */\n  word-break: normal;\n  overflow-wrap: anywhere;\n  line-height: var(--leading-normal);\n}\n\n.tree-count {\n  font-size: var(--text-xs);\n  color: var(--text-subtle);\n  background: var(--bg-surface);\n  padding: 2px var(--space-2);\n  border-radius: var(--radius-sm);\n  flex-shrink: 0;\n  min-width: 20px;\n  text-align: center;\n}\n\n.tree-count-group {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  flex-shrink: 0;\n}\n\n.tree-count-synthetic {\n  color: #d946ef;\n  background: rgba(217, 70, 239, 0.12);\n}\n\n.tree-count-manual {\n  color: #06b6d4;\n  background: rgba(6, 182, 212, 0.12);\n}\n\n.tree-count-notes {\n  color: #06b6d4;\n  background: rgba(6, 182, 212, 0.12);\n  font-weight: var(--font-weight-medium);\n}\n\n/* ============================================\n   ITEM CONTENT WRAPPER\n   ============================================ */\n\n.tree-item-content {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  flex: 1;\n  min-width: 0; /* Allow flex children to shrink */\n}\n\n/* ============================================\n   ACCESSIBILITY\n   ============================================ */\n\n.tree-chevron:focus-visible,\n.tree-checkbox:focus-visible,\n.tree-item:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n/* ============================================\n   PROCESSING STATE\n   ============================================ */\n\n.tree-processing .tree-label {\n  color: var(--text-subtle);\n  font-style: italic;\n}\n\n.tree-processing-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--accent-warning, #f59e0b);\n  flex-shrink: 0;\n  animation: tree-pulse 1.5s ease-in-out infinite;\n}\n\n.tree-processing-track {\n  height: 2px;\n  background: rgba(245, 158, 11, 0.15);\n  border-radius: 1px;\n  margin: 0 var(--space-2) 2px;\n  overflow: hidden;\n}\n\n.tree-processing-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #f59e0b, #fbbf24);\n  border-radius: 1px;\n  transition: width 0.6s ease-out;\n}\n\n.tree-phase-hint {\n  font-size: 0.55rem;\n  color: var(--accent-warning, #f59e0b);\n  opacity: 0.7;\n  flex-shrink: 0;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  font-weight: var(--font-weight-medium);\n}\n\n@keyframes tree-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n/* Uploading state — purple/indigo pulsing */\n.tree-processing-track--uploading {\n  background: rgba(139, 92, 246, 0.15);\n}\n\n.tree-processing-fill--uploading {\n  background: linear-gradient(90deg, #8b5cf6, #a78bfa);\n  animation: tree-upload-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes tree-upload-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n\n.tree-processing-dot--uploading {\n  background: #8b5cf6;\n}\n\n.tree-phase-hint--uploading {\n  color: #8b5cf6 !important;\n}\n\n/* Cloud parse mode — sky blue instead of amber */\n.tree-processing-track--cloud {\n  background: rgba(14, 165, 233, 0.15);\n}\n\n.tree-processing-fill--cloud {\n  background: linear-gradient(90deg, #0ea5e9, #38bdf8);\n}\n\n.tree-processing-dot--cloud {\n  background: #0ea5e9;\n}\n\n.tree-phase-hint--cloud {\n  color: #0ea5e9 !important;\n}\n\n/* Concept-card forging — denim blue, distinct from sky-cloud */\n.tree-processing-track--forging {\n  background: rgba(59, 130, 246, 0.15);\n}\n\n.tree-processing-fill--forging {\n  background: linear-gradient(90deg, #3b82f6, #60a5fa);\n  animation: tree-upload-pulse 1.5s ease-in-out infinite;\n}\n\n.tree-processing-dot--forging {\n  background: #3b82f6;\n  box-shadow: 0 0 6px rgba(59, 130, 246, 0.55);\n}\n\n.tree-phase-hint--forging {\n  color: #60a5fa !important;\n}\n\n/* Forging sub-row — appears UNDER its parent topic/deck row */\n.tree-forging-row {\n  position: relative;\n  margin-left: var(--space-4, 12px);\n  padding: 4px var(--space-2, 8px);\n  display: flex;\n  align-items: center;\n  gap: var(--space-2, 8px);\n  font-size: 0.7rem;\n  color: rgba(96, 165, 250, 0.85);\n  border-left: 1px solid rgba(59, 130, 246, 0.2);\n}\n\n.tree-forging-row .tree-label {\n  font-style: italic;\n  font-size: 0.7rem;\n  color: rgba(96, 165, 250, 0.78);\n}\n\n.tree-forging-row .tree-processing-track {\n  position: absolute;\n  left: var(--space-2, 8px);\n  right: var(--space-2, 8px);\n  bottom: 0;\n  margin: 0;\n}\n\n/* Reduce motion for users who prefer it */\n@media (prefers-reduced-motion: reduce) {\n  .tree-chevron,\n  .tree-children,\n  .tree-exam-children,\n  .tree-item,\n  .tree-processing-dot,\n  .tree-processing-fill {\n    transition: none;\n    animation: none;\n  }\n}\n\n/* Hover-action groups overlay the row's right edge instead of reserving\n   layout space. .tree-topic-actions / .tree-domain-actions are opacity:0\n   at rest but, as in-flow flex children, still consumed ~58px of every\n   row's horizontal budget — squeezing .tree-label into ~126px of a 280px\n   sidebar and forcing premature 2-line ellipsis on long deck/topic names.\n\n   Taking them out of flow (position: absolute) gives .tree-label the full\n   row width at every viewport. The opacity-based hover reveal is unchanged;\n   pointer-events is gated so the invisible overlay never blocks clicks. */\n.tree-item {\n  position: relative;\n}\n\n.tree-topic-actions,\n.tree-domain-actions {\n  position: absolute;\n  right: var(--space-2);\n  top: 50%;\n  transform: translateY(-50%);\n  background: var(--bg-surface-hover, rgba(255, 255, 255, 0.06));\n  border-radius: var(--radius-sm);\n  padding: 2px 3px;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.tree-topic-header:hover .tree-topic-actions,\n.tree-topic-header:focus-within .tree-topic-actions,\n.tree-domain-header:hover .tree-domain-actions,\n.tree-domain-header:focus-within .tree-domain-actions {\n  pointer-events: auto;\n}\n\n/* Sub-desktop chrome tightening (Surface, split-screen, small laptops).\n   At <=1800px the count badge's var(--space-2) padding + 20px min-width +\n   var(--space-3) row padding stay fixed even as the sidebar narrows,\n   eating first-line label width. Tightening them gives long deck/topic\n   names more room before they wrap. 1800px is chosen to catch a Surface\n   at its real CSS width (~1700px) while leaving a 1440p monitor at 100%\n   or 125% scaling (2048-2560px CSS) untouched. */\n@media (max-width: 1800px) {\n  .tree-item {\n    padding: var(--space-2) var(--space-2);\n  }\n\n  .tree-count {\n    padding: 2px var(--space-1);\n    min-width: 16px;\n  }\n\n  .tree-topic-right,\n  .tree-domain-right {\n    gap: 2px;\n  }\n\n  .tree-count-group {\n    gap: 2px;\n  }\n}\n\n/* Narrow-viewport sidebar fixes (Surface, split-screen, small laptops).\n   The sidebar drops to 260px width at <=1024px (SidebarShell.css). At that\n   width, also tighten child indent to reclaim a few more pixels. */\n@media (max-width: 1024px) {\n  .tree-children {\n    margin-left: var(--space-1);\n    padding-left: var(--space-2);\n  }\n\n  .tree-topic-header,\n  .tree-exam-header {\n    padding: var(--space-2) var(--space-1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
